import React, { useState, useEffect } from 'react';

// Only faking needed values
const defaultWindow = {
  document: {
    referer: '',
  },
};

export const useWindow = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted ? window : defaultWindow;
};
